import { ITask as Task } from '../Task';
import { Actions, Action } from './store';

export const startGettingTasks = (): Action => ({
  type: Actions.SET_TASKS_PENDING,
  payload: null,
});

export const gettingTaskFinish = (tasks: Task[]): Action => ({
  type: Actions.SET_TASKS_FINISH,
  payload: tasks,
});

export const gettingTaskError = (error: string): Action => ({
  type: Actions.SET_TASKS_FINISH,
  payload: error,
});

export const taskActionStart = (task: Task): Action => ({
  type: Actions.SET_TASK_ACTION_IN_PROGRESS,
  payload: task,
});

export const taskActionFinish = (task: Task): Action => ({
  type: Actions.SET_TASK_ACTION_FINISH,
  payload: task,
});

export const setTaskAsCompleted = (task: Task): Action => ({
  type: Actions.SET_TASK_STATUS_COMPLETED,
  payload: task,
});

export const setTaskAsNotApplicable = (task: Task): Action => ({
  type: Actions.SET_TASK_STATUS_NOT_APPLICABLE,
  payload: task,
});

export const setTaskAsToDo = (task: Task): Action => ({
  type: Actions.SET_TASK_STATUS_TODO,
  payload: task,
});
